import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { PROJECT_MANAGEMENT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class SapCustomerService {
    private readonly SAP_CUSTOMER_API = `${PROJECT_MANAGEMENT_URL}/sap-customer`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
     * Get available SAP customers (not yet mapped to local customers)
     */
    public getAvailableSapCustomers(params?: {
        searchFilter?: string;
        countryId?: number;
    }): Observable<{ result: { customerCode: string; customerDescription: string }[] }> {
        let queryParams = new HttpParams();

        if (params) {
            if (params.searchFilter && params.searchFilter.trim() !== '') {
                queryParams = queryParams.set('searchFilter', params.searchFilter.trim());
            }
            if (params.countryId) {
                queryParams = queryParams.set('countryId', params.countryId.toString());
            }
        }

        return this.http
            .get<{ result: { customerCode: string; customerDescription: string }[] }>(`${this.SAP_CUSTOMER_API}/available`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }
}
